var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeature2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 523,
    height: 432,
    viewBox: "0 0 523 432",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Feature-2-svg-a",
    x: 0,
    y: 0,
    width: 251,
    height: 432,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4f4e74",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Feature-2-svg-c",
    x: 299,
    y: 60,
    width: 224,
    height: 312,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "d"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#4f4e74",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "d"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 10)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -12, -10)",
    filter: "url(#Feature-2-svg-a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 227,
    height: 408,
    rx: 8,
    transform: "translate(12 10)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25 339)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 177,
    height: 48,
    rx: 8,
    fill: "#d6e3ff"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(17 11)",
    fill: "#1d1c3b",
    fontSize: 16,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.015em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 40,
    y: 17
  }, "Send CP"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24 68)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "none",
    stroke: "#d6e3ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(3 3)",
    fill: "#04be9d"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24 112)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "none",
    stroke: "#d6e3ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24 244)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 2,
    fill: "none",
    stroke: "#d6e3ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 10,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.736,7.839.161,4.354a.527.527,0,0,1,0-.758l.778-.758a.56.56,0,0,1,.778,0L4.125,5.185,9.283.157a.56.56,0,0,1,.778,0l.778.758a.527.527,0,0,1,0,.758L4.514,7.839a.56.56,0,0,1-.778,0Z",
    transform: "translate(0 0.002)",
    fill: "#794bb4"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24 200)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 2,
    transform: "translate(1 1)",
    fill: "none",
    stroke: "#d6e3ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24 288)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 2,
    transform: "translate(1 1)",
    fill: "none",
    stroke: "#d6e3ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(24 22)",
    fill: "#4f4e74",
    fontSize: 16,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.015em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 17
  }, "Parties")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(24 154)",
    fill: "#4f4e74",
    fontSize: 16,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.015em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 17
  }, "Parties")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(56 66)",
    fill: "#4f4e74",
    fontSize: 16,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.015em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 17
  }, "Virtue Bank")), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 96,
    rx: 3.5,
    transform: "translate(152.5 206.5) rotate(90)",
    fill: "#d6e3ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 96,
    rx: 3.5,
    transform: "translate(152.5 294.5) rotate(90)",
    fill: "#d6e3ff"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(56 110)",
    fill: "#4f4e74",
    fontSize: 16,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.015em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 17
  }, "Smart VC")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(56 242)",
    fill: "#4f4e74",
    fontSize: 16,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.015em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 17
  }, "Affiliates")), /*#__PURE__*/React.createElement("path", {
    d: "M50,.5H0",
    transform: "translate(227 203.5)",
    fill: "none",
    stroke: "#4135af",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    opacity: 0.48
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(299 60)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -311, -70)",
    filter: "url(#Feature-2-svg-c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 288,
    rx: 8,
    transform: "translate(311 70)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(40 129)",
    fill: "#4f4e74",
    fontSize: 16,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.015em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 17
  }, "Virtue Bank")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(57 194)",
    fill: "#4f4e74",
    fontSize: 16,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.015em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 5.69,
    y: 17
  }, "and affiliates")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(24 111)",
    fill: "#4135af",
    fontSize: 40,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.015em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 43
  }, "[")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(44 175)",
    fill: "#4135af",
    fontSize: 40,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.015em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 43
  }, "[")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(134 111)",
    fill: "#4135af",
    fontSize: 40,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.015em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 43
  }, "]")), /*#__PURE__*/React.createElement("text", {
    transform: "translate(161 175)",
    fill: "#4135af",
    fontSize: 40,
    fontFamily: "SegoeUI, Segoe UI",
    letterSpacing: "0.015em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 43
  }, "]")), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 152,
    rx: 6,
    transform: "translate(176 72.197) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 152,
    rx: 6,
    transform: "translate(176 40) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 152,
    rx: 6,
    transform: "translate(176 104) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 152,
    rx: 6,
    transform: "translate(176 168) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 16,
    rx: 6,
    transform: "translate(40 200) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 24,
    rx: 6,
    transform: "translate(176 136) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 152,
    rx: 6,
    transform: "translate(176 232) rotate(90)",
    fill: "rgba(121,75,180,0.24)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature2);
export default __webpack_public_path__ + "static/media/feature2.de3e9b66d28041415e837e88ed6ffdf1.svg";
export { ForwardRef as ReactComponent };